import { useEffect } from 'react';
import { generateLocationPinQuerySelector } from '../lib/utils';
import { PROVIDER_DRAWER_OPEN } from '../../machines/map-search/map-search-states';

export default function useKeyboardAccessibilityFocus(
  closeButtonRef,
  state,
  isDrawerLoading
) {
  const { selectedLocation } = state.context;
  const shouldAutofocusCloseButton =
    state.matches(PROVIDER_DRAWER_OPEN) && !isDrawerLoading;
  const focusPin = () => {
    if (typeof window === 'undefined') {
      return;
    }

    const pin = window.document.querySelector(
      generateLocationPinQuerySelector(selectedLocation)
    );

    if (pin) {
      pin.focus();
    }
  };

  useEffect(() => {
    if (shouldAutofocusCloseButton && closeButtonRef?.current) {
      closeButtonRef.current.focus();
    }
  }, [shouldAutofocusCloseButton]);

  return { focusPin };
}
